import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '../services/auth';

const ELIGIBLE_ROLES = ['doctor', 'aide_soignante', 'receptionist', 'laborantin', 'pharmacienne'];

export const simpleEligibleGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const messageService = inject(MessageService, { optional: true });

  if (!authService.isAuthenticated()) {
    router.navigate(['/auth/login']);
    return false;
  }

  const role = authService.currentUser()?.role ?? '';
  if (role === 'patient') {
    router.navigate(['/patient-portal']);
    return false;
  }

  if (!ELIGIBLE_ROLES.includes(role)) {
    localStorage.setItem('viewMode', 'normal');
    messageService?.add({
      severity: 'info',
      summary: 'Vue simplifiée indisponible',
      detail: 'Cette vue est réservée au personnel de terrain.',
      life: 4000,
    });
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
